import React from "react";
import * as Sentry from "@sentry/browser";
import * as Components from "components";
import { syncData } from "actions/users";
import { connect } from "react-redux";
import { withSize } from "react-sizeme";
import constants from "common/constants";
import { showModal } from "actions/modal";
import messages from "utils/messages";
import { connect as connectToSocket } from "actions/sync";
import { format } from "date-fns";
import { fetchHabits } from "actions/habits";
import { withRouter } from "react-router";

class Board extends React.Component {
  constructor(props) {
    super(props);

    let controlPanelWidth = props.controlPanel.isVisible ? 160 : 0;

    let margins = 180 + 150 + controlPanelWidth;
    if (this.props.size.width < 768) margins = 160 + 150;

    this.state = {
      currentDay: format(new Date(), "YYYY-MM-DD"),
      width: null,
      controlPanelWidth,
      numDaysView: parseInt((this.props.size.width - margins) / 60, 10),
      offset:
        constants.numDays -
        parseInt((this.props.size.width - margins) / 60, 10) +
        1,
      statsType: 1,
    };
  }

  componentDidMount() {
    const user = this.props.user;
    if (user) {
      this.props.dispatch(syncData());
      connectToSocket(this.props.user.id);
      Sentry.configureScope((scope) => {
        scope.setUser(user);
      });
    }

    // AUTOREFRESH
    this.interval = setInterval(async () => {
      const currentDay = format(new Date(), "YYYY-MM-DD");

      if (currentDay !== this.state.currentDay) {
        await this.setState(() => ({
          currentDay,
        }));
        this.props.dispatch(fetchHabits());
      }
    }, 1 * 5 * 1000);

    const currentLocation = this.props.location.pathname;
    if (currentLocation === "/subscribe")
      this.props.dispatch(
        showModal("subscription", { showBrightModal: true, class: "premium" })
      );
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let controlPanelWidth = nextProps.controlPanel.isVisible ? 160 : 0;

    let margins = 330;
    if (nextProps.size.width < 768) margins = 310;

    margins += controlPanelWidth;

    if (
      prevState.width !== nextProps.size.width ||
      prevState.controlPanelWidth !== controlPanelWidth
    ) {
      return {
        width: nextProps.size.width,
        controlPanelWidth,
        numDaysView: parseInt((nextProps.size.width - margins) / 60, 10),
        offset:
          constants.numDays -
          parseInt((nextProps.size.width - margins) / 60, 10) +
          1,
      };
    }

    return null;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  nextDates() {
    this.setState((prevState) => {
      let newOffset = prevState.offset + (prevState.numDaysView - 1);
      if (newOffset > constants.numDays - prevState.numDaysView + 1) {
        newOffset = constants.numDays - prevState.numDaysView + 1;
      }
      return { offset: newOffset };
    });
  }

  prevDates() {
    this.setState((prevState) => {
      let newOffset = prevState.offset - (prevState.numDaysView - 1);
      if (newOffset < 0) newOffset = 0;

      return { offset: newOffset };
    });
  }

  showNewHabitModal() {
    this.props.dispatch(showModal("newHabit", { title: messages.NEW_HABIT }));
  }

  showPremiumFeatureModal() {
    this.props.dispatch(
      showModal("premiumFeature", { class: "premiumfeature" })
    );
  }

  showEditModal(habit) {
    this.props.dispatch(
      showModal("editHabit", { title: messages.EDIT_HABIT, habit })
    );
  }

  showStats(statsType) {
    this.setState({ statsType });
  }

  render() {
    return (
      <div className="applayout">
        {!this.props.showSpinner ? ( // eslint-disable-line
          this.props.rows.length || this.props.boardFilter.groupId ? (
            <div className="app-wrapper not-select">
              <Components.Header
                numDaysView={this.state.numDaysView}
                offset={this.state.offset}
                baseDate={this.props.baseDate}
                currentDay={this.state.currentDay}
                nextDates={this.nextDates.bind(this)}
                prevDates={this.prevDates.bind(this)}
                statsType={this.state.statsType}
              />
              <div className="clear" />
              <Components.Menu
                rows={this.props.rows}
                user={this.props.user}
                showEditModal={this.showEditModal.bind(this)}
                dispatch={this.props.dispatch}
              />
              <div
                className={`${
                  this.props.controlPanel.isVisible
                    ? "board-page-with-control-panel"
                    : "board-page"
                }`}
              >
                <Components.Board
                  habitsDates={this.props.habitsDates}
                  currentDay={this.state.currentDay}
                  numDaysView={this.state.numDaysView}
                  offset={this.state.offset}
                  rows={this.props.rows}
                  statsType={this.state.statsType}
                  user={this.props.user}
                  showPremiumFeatureModal={this.showPremiumFeatureModal.bind(
                    this
                  )}
                />
              </div>
              <div className="clear" />
              <Components.BoardFooter
                numDaysView={this.state.numDaysView}
                offset={this.state.offset}
                currentDay={this.state.currentDay}
                hideNewHabit={this.props.isArchive}
                showNewHabitModal={this.showNewHabitModal.bind(this)}
                showPremiumFeatureModal={this.showPremiumFeatureModal.bind(
                  this
                )}
                showStats={this.showStats.bind(this)}
                numHabits={this.props.rows.length}
                user={this.props.user}
              />
            </div>
          ) : (
            <Components.NoHabits
              isArchive={this.props.isArchive}
              showNewHabitModal={this.showNewHabitModal.bind(this)}
            />
          )
        ) : (
          <div className="spinner" />
        )}
        <div className="clear" />
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const currentLocation = props.location.pathname;
  const isArchive = currentLocation === "/archive";
  const groupFilterId = state.boardFilter.groupId;

  let rows;
  if (isArchive) {
    rows = state.archive.habits.map((habit) => ({
      ...state.habitsEntities[habit],
      isHabit: true,
    }));
  } else {
    rows = state.rows
      .filter((row) => {
        if (groupFilterId) {
          if (row.isGroup) return false;
          if (row.isHabit) {
            const habit = state.habitsEntities[row.id];

            return (
              habit &&
              habit.group_id &&
              habit.group_id.toString() === groupFilterId.toString()
            );
          }
        }

        //return true;

        if (row.isGroup) return true;
        const habit = state.habitsEntities[row.id];
        if (!habit) return false;
        if (!habit.group_id) return true;
        return state.groupsEntities[habit.group_id].expanded;
      })
      .map((row) => {
        if (row.isHabit) return { ...row, ...state.habitsEntities[row.id] };
        if (row.isGroup) return { ...row, ...state.groupsEntities[row.id] };
      });
  }

  return {
    rows,
    isArchive,
    habitsDates: rows.map((habit) => state.dates[habit.id] || {}),
    baseDate: state.basedate,
    showSpinner: state.queue.fetchingHabits && state.queue.initialFetch,
    user: state.user,
    controlPanel: state.controlPanel,
    boardFilter: state.boardFilter,
  };
}

export default withRouter(connect(mapStateToProps)(withSize()(Board)));
